import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import FloatingBetslipPillImpl from './floating-betslip-pill.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A View that represents the Floating betslip pill.
 *
 * @class FloatingBetslipPill
 * @memberof Mojito.Modules
 */

/**
 * FloatingBetslipPill prop types.
 *
 * @memberof Mojito.Modules
 *
 * @property {boolean} isOpen - True if floating betslip pill should be opened, false otherwise.
 * @property {boolean} [isBetslipCommitted = false] - True if betslip button should be displayed as committed, false otherwise.
 * @property {boolean} [isQuickBetslip = false] - Indication if quick betslip is showing.
 * @property {boolean} [enableFreebetsIndication] - Flag to control if free bet indication should be shown on betslip button.
 * @property {Function} [onClick = () => {}] - Callback triggered once button has been clicked.
 */

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isBetslipCommitted: PropTypes.bool,
    isQuickBetslip: PropTypes.bool,
    enableFreebetsIndication: PropTypes.bool,
    onClick: PropTypes.func,
};

const defaultProps = {
    isBetslipCommitted: false,
    isQuickBetslip: false,
    onClick: noop,
};

export default UIView('FloatingBetslipPill', FloatingBetslipPillImpl, propTypes, defaultProps);
